<!-- Top Section -->
<div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Contact Us</h2>
        <p>
          We would love to hear from you! Whether you have a question about our
          programs, want to schedule a visit, or are interested in a
          collaboration, please get in touch with us.
        </p>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img
          src="assets/ivimg/contactH.svg"
          alt="Girl Learning Pottery"
          class="img-fluid"
        />
      </div>
    </div>
  </div>
</div>

<!-- Contact Wrapper -->
<div class="contact-wrapper">
  <!-- Left Image -->
  <div class="contact-image">
    <img src="assets/ivimg/contact1.svg" alt="Kids group left" />
  </div>

  <!-- Contact Form -->
  <div class="contact-form">
    <h2>Contact Us -</h2>

    <!-- Reactive Form -->
    <form [formGroup]="contactForm" >
      <!-- Name -->
    <!-- Name -->
<input
  type="text"
  formControlName="name"
  placeholder="Enter Your Name / School Name"
  class="form-control mt-2"
/>
 <!-- <div *ngIf="submitted && f['name'].hasError('required')" class="invalid-feedback">
      Name is required (min 3 chars).
 </div> -->
<div class="text-danger" *ngIf="f['name'].invalid && (f['name'].touched || submitted)">
  Name is required (min 3 chars).
</div>

<!-- Contact No -->
<input
  type="text"
  class="form-control"
  formControlName="contactNo"
  placeholder="Enter Your Contact No."
/>
<div class="text-danger" *ngIf="f['contactNo'].invalid && (f['contactNo'].touched || submitted)">
  Enter a valid 10-digit number.
</div>

<!-- Email -->
<input
  type="email"
  class="form-control"
  formControlName="emailId"
  placeholder="Enter Your Email ID"
/>
<div class="text-danger" *ngIf="f['emailId'].invalid && (f['emailId'].touched || submitted)">
  Enter a valid email.
</div>

<!-- Thoughts -->
<textarea
  class="form-control mt-3"
  formControlName="thoughts"
  placeholder="Write Your Thoughts Here"
></textarea>
<div class="text-danger" *ngIf="f['thoughts'].invalid && (f['thoughts'].touched || submitted)">
  Please enter at least 5 characters.
</div>
      <!-- Submit Button -->
      <button
        type="submit"
        class="btn btn-primary mt-3"
        (click)="onSubmit()">
        Send
      </button>
    </form>
  </div>

  <!-- Right Image -->
  <div class="contact-image">
    <img src="assets/ivimg/contact2.svg" alt="Kids group right" />
  </div>
</div>
